// @material-ui/core
import { Typography } from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";

const styles = theme => ({
  title: {
    marginBottom: "15px"
  }
});

class About extends Component {
  render() {
    const { classes } = this.props;

    const doubleBreak = (
      <React.Fragment>
        <br />
        <br />
      </React.Fragment>
    );

    return (
      <div>
        <Typography type="display1" className={classes.title}>
          About us
        </Typography>
        <Typography type="body2">
          CLOUDPILOTS Software & Consulting GmbH is focused on cloud-based mail,
          collaboration and ITSM solutions. We enable our customers’ digital
          transformation to be a true digital business based on a full service
          stack of G Suite, Google Cloud Platform, Office 365, Azure, Freshdesk,
          Freshservice and ServiceNow - with corresponding consulting,
          deployment, development and change management services.{doubleBreak}
          Since 2011 our certified specialists ensure that your move into the
          cloud will become a full success. CLOUDPILOTS has developed
          standardized cloud deployment and consulting procedures to ensure an
          efficient, safe and smooth cloud enablement. Our employees have many
          years of experience in IT, cloud solutions and IT service management
          and have handled projects from SMB's to very large enterprises.{
            doubleBreak
          }
          CLOUDPILOTS is an ISO-9001-certified subsidiary company of the
          TIMETOACT GROUP, which is based in Cologne and operates successfully
          in the IT-market since 1998 with more than 350 employees in several
          locations in Germany, Austria and Switzerland.
        </Typography>
      </div>
    );
  }
}

About.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(About);



// WEBPACK FOOTER //
// ./src/pages/About.js